import { TravelProposalModel } from './../../../Models/TravelProposalModel';
import { MedmalProposalModel } from './../../../Models/MedmalProposalModel';
import { TransInfoModel, PayfortTransInfoModel } from './../../../Models/ProposalModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { restURL } from '../../../Models/restURL';
import { motorProposalService } from '../../../Services/motorProposalService';
import { ProposalModel } from '../../../Models/ProposalModel'
import { proposalResMdl } from '../../../Models/proposalResMdl'
import { RegModel } from '../../../Models/RegModel';
import { FortPaymentReq } from '../../../Models/FortPaymentReq';
import { MedmalTransInfoModel } from '../../../Models/MedmalProposalModel';
import { userService } from './../../../Services/userService';
import { mdlSadadBillerReq } from '../../../Models/mdlSadadBillerReq';
import { mdlSadadBillerRes } from '../../../Models/mdlSadadBillerRes';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { mdlPaymentDetailsRes_DH } from '../../../Models/mdlPaymentDetailsRes_DH';

@Component({
    selector: 'PayfortPayment',
    templateUrl: './PayfortPayment.html',
    styleUrls: ['./PayfortPayment.css']
})
export class PayfortPayment {

    public isShowLoading: boolean = false;
    public proposalObj: ProposalModel = new ProposalModel();
    public paymentReq: proposalResMdl = new proposalResMdl();
    public medmalPaymentReq: MedmalProposalModel = new MedmalProposalModel();
    public travelPaymentReq: TravelProposalModel = new TravelProposalModel();
    public agreeTerms: boolean = false;
    public ShowSadadBillGenerate: boolean = false;

    //  public transObj:TransInfoModel=new TransInfoModel();
    public transObj: PayfortTransInfoModel = new PayfortTransInfoModel();
    public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    public fortReq: FortPaymentReq = new FortPaymentReq();

    public objGenerateBillReq: mdlSadadBillerReq = new mdlSadadBillerReq();
    public objGenerateBillRes: mdlSadadBillerRes = new mdlSadadBillerRes();
    public BillExpiryDate: string;
    public BillExpiryTime: string;
    public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
    public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
    public objPaymentDetailsRes_DH: mdlPaymentDetailsRes_DH = new mdlPaymentDetailsRes_DH();

    constructor(private translate: TranslateService, private EncriptService: motorProposalService, private router: Router, private http: HttpClient, public url: restURL, private userinfo: userService) {
        this.agreeTerms = false;

        let NavType = sessionStorage.getItem("NavFrom");
        if (NavType == "PRB") {
            if (sessionStorage.getItem("fpCode") == "5515") {
                this.proposalObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("paymentObj")));

                this.paymentReq.Email = this.proposalObj.transObj.Email
                this.paymentReq.EncPayInfo = this.proposalObj.transObj.EPayInfo;
                this.paymentReq.EproposalNo = this.proposalObj.transObj.EProposalNo;
                this.paymentReq.InsuredName = this.proposalObj.transObj.InsuredName;
                this.paymentReq.MobileNo = this.proposalObj.transObj.Mobile;
                this.paymentReq.PaySig = this.proposalObj.transObj.PaySig;
                this.paymentReq.ProductCode = this.proposalObj.transObj.ProductCode;
                this.paymentReq.proposalNo = this.proposalObj.transObj.ProposalNo;
                this.paymentReq.RegNo = this.proposalObj.transObj.RegNo;
                this.paymentReq.TotalPremium = this.proposalObj.transObj.Premium.toString();
            }
            else if (sessionStorage.getItem("fpCode") == "5014") {
                this.medmalPaymentReq = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("MedmalpaymentObj")));
                this.paymentReq.Email = this.medmalPaymentReq.transObj.Email
                this.paymentReq.EncPayInfo = this.medmalPaymentReq.transObj.EPayInfo;
                this.paymentReq.EproposalNo = this.medmalPaymentReq.transObj.EProposalNo;
                this.paymentReq.InsuredName = this.medmalPaymentReq.transObj.InsuredName;
                this.paymentReq.MobileNo = this.medmalPaymentReq.transObj.Mobile;
                this.paymentReq.PaySig = this.medmalPaymentReq.transObj.PaySig;
                this.paymentReq.ProductCode = this.medmalPaymentReq.transObj.ProductCode;
                this.paymentReq.proposalNo = this.medmalPaymentReq.transObj.ProposalNo;
                this.paymentReq.RegNo = this.medmalPaymentReq.transObj.RegNo;
                this.paymentReq.TotalPremium = this.medmalPaymentReq.transObj.Premium.toString();

            }
            else if (sessionStorage.getItem("fpCode") == "6001") {

                this.travelPaymentReq = JSON.parse(sessionStorage.getItem("TravelpaymentObj"));
                this.paymentReq.Email = this.travelPaymentReq.transObj.Email
                this.paymentReq.EncPayInfo = this.travelPaymentReq.transObj.EPayInfo;
                this.paymentReq.EproposalNo = this.travelPaymentReq.transObj.EProposalNo;
                this.paymentReq.InsuredName = this.travelPaymentReq.transObj.InsuredName;
                this.paymentReq.MobileNo = this.travelPaymentReq.transObj.Mobile;
                this.paymentReq.PaySig = this.travelPaymentReq.transObj.PaySig;
                this.paymentReq.ProductCode = this.travelPaymentReq.transObj.ProductCode;
                this.paymentReq.proposalNo = this.travelPaymentReq.transObj.ProposalNo;
                this.paymentReq.RegNo = this.travelPaymentReq.transObj.RegNo;
                this.paymentReq.TotalPremium = this.travelPaymentReq.transObj.Premium.toString();
            }
            else if (sessionStorage.getItem("fpCode") == "5018") {

                this.objPaymentDetailsRes_DH = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("PaymentDetails_DH")));
                this.paymentReq.Email = this.objPaymentDetailsRes_DH.Email
                this.paymentReq.EncPayInfo = this.objPaymentDetailsRes_DH.EPayInfo;
                this.paymentReq.EproposalNo = this.objPaymentDetailsRes_DH.EProposalNo;
                this.paymentReq.InsuredName = this.objPaymentDetailsRes_DH.Name;
                this.paymentReq.MobileNo = this.objPaymentDetailsRes_DH.Mobile;
                this.paymentReq.PaySig = this.objPaymentDetailsRes_DH.PaySig;
                this.paymentReq.ProductCode = this.objPaymentDetailsRes_DH.ProductCode;
                this.paymentReq.proposalNo = this.objPaymentDetailsRes_DH.ProposalNo;
                this.paymentReq.RegNo = this.objPaymentDetailsRes_DH.RegNo;
                this.paymentReq.TotalPremium = this.objPaymentDetailsRes_DH.TotalPremium.toString();
            }
            else {

            }
            //alert(JSON.stringify(this.paymentReq));
        }
        else if (NavType == "PR") {

            //this.transObj = JSON.parse(sessionStorage.getItem("transObj"));
            this.transObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("transObj")));

            this.paymentReq.Email = this.transObj.Email;
            this.paymentReq.EncPayInfo = this.transObj.EPayInfo;
            this.paymentReq.EproposalNo = this.transObj.EProposalNo;
            this.paymentReq.InsuredName = this.transObj.InsuredName;
            this.paymentReq.MobileNo = this.transObj.Mobile;
            this.paymentReq.PaySig = this.transObj.PaySig;
            // this.paymentReq.PMethod="CR";
            this.paymentReq.ProductCode = this.transObj.ProductCode;
            this.paymentReq.proposalNo = this.transObj.ProposalNo;
            this.paymentReq.RegNo = this.transObj.RegNo;
            this.paymentReq.TotalPremium = this.transObj.Premium;
        }
    }

    goCancel() {
        this.router.navigate(['NewDashboard/Proposals']);

    }


    proceedToPay() {
        if (!this.agreeTerms) {
            Swal("Please Check Agree terms Button");
            return;
        }
        if (this.paymentReq.PMethod == "SDB") {
            this.GenerateBill();
        } else {
            this.isShowLoading = true;
            sessionStorage.setItem("PaymentMethod", JSON.stringify(this.paymentReq.PMethod));

            if (this.paymentReq.PMethod == "MD") {
                this.paymentReq.PMethod = "CR";
            }
            //sessionStorage.setItem("PaymentReq", JSON.stringify(this.paymentReq));
            sessionStorage.setItem("PaymentReq", this.EncriptService.EncriptObject(JSON.stringify(this.paymentReq)));


            this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.paymentReq));
            //this.http.post<FortPaymentReq>(this.url.baseURL + "/Payfort/savePaymentReq", this.paymentReq, this.userinfo.getHttpOptions())
            this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Payfort/savePaymentReq", this.objPayloadRequest, this.userinfo.getHttpOptions())
                .toPromise().then((result) => {
                    //this.fortReq = result;
                    this.isShowLoading = false;

                    //New Line Start
                    this.objPayloadResponse = result;
                    this.fortReq = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
                    //NewLine End

                    if (this.fortReq.st.StatusCode == "S") {
                        if (this.fortReq.SurplusAmount > 0)
                            Swal(this.translate.instant("You are eligible for surplus amount of ") + this.fortReq.SurplusAmount.toString() + this.translate.instant(" SAR from previous years.This will be deducted if you finalize the policy and proceed for payment."));
                        //sessionStorage.setItem("fortObj", JSON.stringify(this.fortReq));
                        sessionStorage.setItem("fortObj", this.EncriptService.EncriptObject(JSON.stringify(this.fortReq)));
                        this.router.navigate(['NewDashboard/PayfortConfirm']);
                    }
                    else {
                        Swal(this.fortReq.st.StatusDesc);
                    }

                }, (error) => {
                    this.isShowLoading = false;
                    Swal("Invalid!,Please try again later");
                });
        }

    }


    GenerateBill() {
        this.objGenerateBillReq.ProposalNo = this.paymentReq.proposalNo;
        this.objGenerateBillReq.RegNo = this.paymentReq.RegNo;
        this.objGenerateBillReq.ProductCode = this.paymentReq.ProductCode;
        this.objGenerateBillReq.Token = this.userinfo.getToken();
        this.objGenerateBillReq.Lang = sessionStorage.getItem("Language");
        this.objGenerateBillReq.InsuredIdNo = sessionStorage.getItem("IqamaNo");//this.proposalObj.newPolicyObj.IqamaNo;

        this.isShowLoading = true;

        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objGenerateBillReq));

        //this.http.post<mdlSadadBillerRes>(this.url.baseURL + "/Payfort/GenerateBill", this.objGenerateBillReq, this.userinfo.getHttpOptions())
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Payfort/GenerateBill", this.objPayloadRequest, this.userinfo.getHttpOptions())
            .toPromise().then((result) => {
                this.isShowLoading = false;
                //this.objGenerateBillRes = result;
                //New Line Start
                this.objPayloadResponse = result;
                this.objGenerateBillRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
                //NewLine End

                if (this.objGenerateBillRes.StatusCode == "S") {
                    this.BillExpiryDate = this.objGenerateBillRes.BillExpiryDate.split("T")[0];
                    this.BillExpiryTime = this.objGenerateBillRes.BillExpiryDate.split("T")[1];
                    if (sessionStorage.getItem("Language") == "en")
                        Swal("You can pay before " + this.BillExpiryDate + " " + this.BillExpiryTime + ", by selecting the company code 196 via SADAD system");
                    else
                        //swal(" باختيار رمز الشركة 196 عبر نظام سداد،" + " " + this.BillExpiryTime + " " + this.BillExpiryDate + " " + " يمكنكم السداد قبل " + this.objGenerateBillRes.BillNo + " تم إصدار فاتورة سداد");

                        Swal(" تم إصدار فاتورة سداد" + "  " + this.objGenerateBillRes.BillNo + "   " + " يمكنكم السداد قبل " + " " + this.BillExpiryTime + " " + this.BillExpiryDate + " " + " باختيار رمز الشركة 196 عبر نظام سداد،");

                    if (this.objGenerateBillRes.SurplusAmount > 0)
                        Swal(this.translate.instant("You are eligible for surplus amount of ") + this.objGenerateBillRes.SurplusAmount.toString() + this.translate.instant(" SAR from previous years.This will be deducted if you finalize the policy and proceed for payment."));

                    this.router.navigate(['/NewDashboard/Proposals']);
                } else {
                    Swal(this.objGenerateBillRes.StatusDesc);
                    this.router.navigate(['/NewDashboard/Proposals']);
                }

            }, (error) => {
                this.isShowLoading = false;
                Swal("Invalid!,Please try again later");
            });


    }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Payfort/PayfortPayment/PayfortPayment.ts